function canonical(value) {
  if (Array.isArray(value)) return value.map(canonical)
  if (value && typeof value === 'object') return Object.fromEntries(Object.keys(value).sort().map((key) => [key, canonical(value[key])]))
  return value
}

// Include effective theme and reuse bindings; the ordinary dirty indicator
// deliberately excludes theme changes and cannot identify an exact preview.
export function draftPreviewFingerprint(document, bindings, selected, scenario = null) {
  return JSON.stringify(canonical({ document, bindings, draftId: selected?.id, revision: selected?.revision, scenario }))
}

export function draftPreviewUnavailable(device, selected) {
  if (!selected?.id) return 'Save this experience once before sending a preview.'
  if (device.status === 'expired') return 'Pair this phone again to preview your edits.'
  if (device.status === 'offline' || device.status === 'pairing') return 'Open the paired app and wait for it to connect.'
  return null
}

export function matchesDraftPreviewReport(device) {
  const target = device.draft_preview
  const report = device.report
  return Boolean(target && report && report.preview_snapshot_id === target.snapshot_id &&
    report.manifest_version === target.manifest_version && report.content_digest === target.content_digest &&
    report.tenant_id === target.tenant_id && report.environment === target.environment && report.channel === target.channel &&
    report.phase === device.rehearsal_phase)
}

export function draftPreviewStatus(device, sent, fingerprint) {
  const target = device.draft_preview
  if (!target) return null
  const known = sent?.editorSnapshotId === target.editor_snapshot_id
  const current = known && sent.fingerprint === fingerprint
  const source = current ? 'Current edits' : known ? 'Earlier edits' : 'Snapshot from another editor'
  if (device.status === 'offline') return { label: 'Preview offline', description: `${source} were sent. Reconnect this phone before checking what it displays.`, tone: 'warning' }
  if (device.status === 'rejected' && matchesDraftPreviewReport(device)) return { label: 'Preview rejected', description: 'The phone restored its published experience. Reconnect the app and send a new preview.', tone: 'warning' }
  if (device.status === 'rendered' && device.report?.status === 'rendered' && matchesDraftPreviewReport(device)) return { label: current ? 'Current edits rendered' : 'Earlier snapshot rendered', description: `${source} confirmed on this phone.`, tone: 'success' }
  return { label: 'Rendering preview', description: `${source} sent · waiting for this phone to draw the snapshot.`, tone: 'default' }
}
